import React from 'react';

const TemplateWatermark = (props) => {
    return (
        <>
            {
                props.watermark !== "" ?
                    <div className={`watermark-op logo-${props.watermark.position} logo-style`}><img src={props.watermark.url} alt="watermark"/></div>
                    : ''
            }
        </>
    );
};

export default TemplateWatermark;
